import CheckboxIconWidget from "./CheckboxIconWidget";

export default CheckboxIconWidget;